import ReactDOM from 'react-dom/client';
import './styles.css';
import { Providers } from './providers';
import * as Sentry from '@sentry/react';
import { env, isLocal } from '@/config';

Sentry.init({
  dsn: 'https://e4a3c40bde4b30e43460a795ded374d7@o4510147544350720.ingest.us.sentry.io/4510147548151808',
  sendDefaultPii: false,
  environment: env,
  enabled: !isLocal,
});

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById('app')!;

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<Providers />);
}
